import {
    Configuration,
    InvoiceApi,
    PlanApi,
    SubscriptionApi,
    TransactionApi,
    UserApi,
} from '@videoblocks/subscription-service-client';

export const subscriptionServiceConfig = new Configuration({
    basePath: process.env.SUBSCRIPTION_SERVICE_HOST ?? 'http://localhost:4020',
});

export const userApi = new UserApi(subscriptionServiceConfig);
export const transactionApi = new TransactionApi(subscriptionServiceConfig);
export const planApi = new PlanApi(subscriptionServiceConfig);
export const subscriptionApi = new SubscriptionApi(subscriptionServiceConfig);
export const invoiceApi = new InvoiceApi(subscriptionServiceConfig);
